import SectionVideoPlayerSection from './sectionVideoPlayerSection';

export default SectionVideoPlayerSection;
